<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование акции" : "Добавление акции"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12 sm8)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='item.name'
            label='Название'
          )
        v-flex(xs12 sm4)
          v-text-field(
            :error='errors.has("discount")'
            :error-messages='errors.first("discount")'
            v-model.number='item.discount'
            label='Скидка'
          )
        v-flex(xs12)
          v-select(
            :items='item.offices'
            :return-object='false'
            v-model='offices'
            label='Выберите офисы'
            item-text='office_name'
            item-value='id'
            multiple
            chips
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("description")'
            :error-messages='errors.first("description")'
            v-model='item.description'
            label='Описание'
          )
        v-flex(xs12 sm6)
          s-datetime-picker(
            :validator='errors'
            v-model='item.start_time'
            label='Дата начала'
            name='start_time'
          )
        v-flex(xs12 sm6)
          s-datetime-picker(
            :validator='errors'
            v-model='item.stop_time'
            label='Дата завершения'
            name='stop_time'
          )
        v-flex(v-if='item.moderation_comment' xs12)
          v-text-field(
            :error='errors.has("moderation_comment")'
            :error-messages='errors.first("moderation_comment")'
            v-model='item.moderation_comment'
            label='Комментарий'
            disabled
          )
        v-flex(xs12 sm4)
          s-image-upload(
            :src='item.avatar_url'
            v-model='item.avatar'
            label='Картинка акции'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading'
        @click='onSave'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { createFormData } from '@/utils'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id', 'organizationId'],

  data: () => ({
    item: {},
    startDate: null,
    endDate: null,
    startTime: null,
    endTime: null
  }),

  async created() {
    // TODO: что-то здесь не так, как мне кажется
    if (this.id) {
      try {
        this.item = (await this.fetchSingle({ id: this.id })).data
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки акции')
      }
    } else {
      let { organizationId } = this

      try {
        this.item = (await this.createEmpty({
          organization_id: organizationId
        })).data

        this.item.stop_time = new Date().toString()
      } catch (e) {
        this.$root.showSnack('Ошибка создания формы')
      }

      this.item.organization_id = organizationId
    }
  },

  methods: {
    async onSave() {
      let data = createFormData(this.item)

      data.append('avatar', this.item.avatar)
      data.append('office_ids', this.offices.join(','))

      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data
          })
        } else {
          await this.create({ data })
        }

        this.$root.showSnack(`Акция сохранена`)
        this.$router.go(-1)
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('partner/actions', [
      'fetchSingle',
      'update',
      'create',
      'createEmpty'
    ])
  },

  computed: {
    offices: {
      get() {
        let { office_ids } = this.item

        if (!office_ids) {
          return []
        }

        return office_ids.split(/,/).map(x => +x)
      },

      set(val) {
        this.item.office_ids = val.join(',')
      }
    },

    ...mapGetters('partner/actions', ['isLoading'])
  }
}
</script>
